import { useFetcher, useLoaderData, useNavigate } from '@remix-run/react';
import { getStaticLinkPath } from './getters';
import type { loader } from '~/routes/_index';
import type { AccountButtonGeneral, StaticLinks } from './types';
import { addParametersToURL } from '~/services/links';

export function useAuthButtonsOnClick(general: AccountButtonGeneral) {
  const { staticLinks, layoutIdOverride } = useLoaderData<typeof loader>();
  const fetcher = useFetcher();
  const navigate = useNavigate();

  const appendLayoutId = (path: string): string => {
    if (!layoutIdOverride || !path.startsWith('/')) return path;
    return addParametersToURL(path, { layoutId: layoutIdOverride });
  };

  return {
    sign_in: (e: any) => {
      e.preventDefault();
      navigate(appendLayoutId('/login'));
    },
    sign_up: () => {
      if (general.sign_up_link_type === 'external_link') {
        window.location.href = general?.sign_up_link_path || '/';
        return;
      }

      window.location.href = appendLayoutId(
        getStaticLinkPath(
          staticLinks as StaticLinks,
          general.sign_up_link_target
        )
      );
    },
    sign_out: (e: any) => {
      e.preventDefault();
      fetcher.submit(
        {},
        { action: appendLayoutId('/api/logout'), method: 'post' }
      );
    },
  };
}
